"use client"

import { cn } from "@/lib/utils"
import { NumberTicker } from "@/components/ui/number-ticker"
import { YEARS_SINCE_FOUNDING } from "@/lib/build-date"

const stats = [
  { value: 17, suffix: "", label: "salariés" },
  // YEARS_SINCE_FOUNDING vient de NEXT_PUBLIC_BUILD_TIME (figé au build)
  // au lieu de `new Date().getFullYear() - 1986` qui pouvait diverger
  // entre SSR et hydration et causer un React error #418.
  { value: YEARS_SINCE_FOUNDING, suffix: "", label: "ans de savoir-faire" },
  { value: 600, suffix: " m²", label: "d'atelier" },
  { value: 2.3, suffix: " millions", label: "dents carbure affûtées par an" },
] as const

export function StatsCounter() {
  return (
    <section className="bg-[var(--surface-sunken)] section-tight px-4 md:px-6">
      <div className="mx-auto max-w-7xl">
        {/*
          Flat single-card layout (previously used the Luma nested
          pattern: outer translucent ring + inner solid card). When
          four stat cards sit in a row the double-rounded-corner from
          the nested wrapper read as a visual artefact — two concentric
          corners with a 6 px gap between them where the outer ring
          peeks out. Simplified to a single border + subtle hover lift
          so the stat numbers stay the focus.
        */}
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 md:gap-5">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className={cn(
                "rounded-2xl border border-border bg-card p-5 md:p-7",
                "transition-[transform,box-shadow,border-color] duration-300 ease-[var(--ease-premium)]",
                "hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-[var(--shadow-md)]",
              )}
              style={{ animationDelay: `${index * 50}ms` }}
            >
              {/*
                whitespace-nowrap + inline NumberTicker keeps "600 m²"
                and "2.3 millions" on a single line inside the narrow
                2-col mobile grid. `text-balance` on the label wraps
                it into even lines rather than the single-word-per-
                line stack from the earlier bug report.
              */}
              <p className="font-[family-name:var(--font-geist-mono)] whitespace-nowrap text-2xl font-bold tabular-nums text-primary sm:text-3xl md:text-5xl">
                <NumberTicker
                  value={stat.value}
                  decimalPlaces={stat.value % 1 !== 0 ? 1 : 0}
                />
                {stat.suffix ? (
                  <span className="text-[0.55em] font-semibold tracking-normal">
                    {stat.suffix}
                  </span>
                ) : null}
              </p>
              <p
                className="mt-2 text-sm leading-snug text-muted-foreground"
                style={{ textWrap: "balance" }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
